import KnownActionTranslationsPage from './KnownActionTranslationsPage';

export default KnownActionTranslationsPage;